
import React from 'react';
import { Badge } from '../../../types/index';
import { SkillBadgeIcon } from '../../../components/common/Icons';

interface BadgesTabProps {
  badges: { [category: string]: Badge[] };
}

const BadgesTab: React.FC<BadgesTabProps> = ({ badges }) => {
  return (
    <section>
      <h2 className="h5 fw-bold text-dark mb-4">Badges & Skills</h2>
      <div className="d-flex flex-column gap-4">
        {Object.entries(badges).map(([category, badgeItems]) => (
          <div key={category}>
            <h3 className="h6 fw-semibold text-dark mb-3">{category}</h3>
            <div className="d-flex flex-wrap gap-2">
              {badgeItems.map((badge, index) => (
                <span key={index} className="badge rounded-pill text-dark-emphasis fw-medium p-2 px-3 d-inline-flex align-items-center border bg-light">
                  {badge.iconUrl ? (
                     <img 
                        src={badge.iconUrl} 
                        alt="" 
                        className="me-2" 
                        style={{ width: '1.5rem', height: '1.5rem', objectFit: 'contain' }} 
                     />
                  ) : (
                     <SkillBadgeIcon className="me-2 text-primary" style={{ height: '1rem', width: '1rem' }} />
                  )}
                  {badge.name}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BadgesTab;
